import type { RouteLocationNormalized, RouteRecordRaw } from 'vue-router'

export const salesAdminRouter: RouteRecordRaw[] = [
  {
    children: [
      {
        component: async () => import('../views/SalesAdminListView.vue'),
        meta: {
          roles: ['pb:super'],
          title: 'sales.dashboard',
        },
        name: 'admin.sales',
        path: '',
      },
      {
        children: [
          {
            component: async () =>
              import('../components/SalesLocationTable.vue'),
            name: 'admin.sales.brand.locations',
            path: 'locations',
            props: (route: RouteLocationNormalized) => ({
              brandId: route.params.brandId,
            }),
          },
          {
            component: async () => import('../components/SalesTeamSection.vue'),
            name: 'admin.sales.brand.team',
            path: 'team',
            props: (route: RouteLocationNormalized) => ({
              brandId: route.params.brandId,
            }),
          },
        ],
        component: async () => import('../views/SalesAdminBrandView.vue'),
        meta: {
          roles: ['pb:super'],
          title: 'sales.dashboard',
        },
        name: 'admin.sales.brand',
        path: 'brands/:brandId',
        props: (route: RouteLocationNormalized) => ({
          brandId: route.params.brandId,
        }),
        redirect: { name: 'admin.sales.brand.locations' },
      },
    ],
    component: async () => import('../views/SalesAdminView.vue'),
    meta: {
      roles: ['pb:super'],
    },
    path: 'admin/sales',
  },
]
